import React, { Component } from 'react';
import Chart from 'react-google-charts';

class CategoryCalendar extends Component {
	constructor() {
		super()

		this.state = {
			obj: {
				title: null,
				data: [
					[
						{type: 'date', id: 'data'},
						{type: 'number', id: 'count'}
					]
				]
			}
		}
	}
	componentDidMount(){
		let { category } = this.props;
		let { obj } = this.state;

		obj.title = category.category;
		obj.total = category.count;
		category.visits.forEach(visit => {
			obj.data.push([
				new Date(visit.date),
				visit.count
			])
		})

		this.setState({obj});
	}

	render(){
		let { obj } = this.state;

		if(obj.title){
			return (
				<div>
					<Chart
					  width={1000}
					  height={350}
					  chartType="Calendar"
					  loader={<div>Loading Chart</div>}
					  data={obj.data}
					  options={{
					    title: obj.title + ' (' + obj.total + ')'
					  }}
					/>
				</div>
			)
		}

		return (
			<div>
			</div>
		)
	}
}

export default class Calendar extends Component {
	constructor(){
		super()
		this.state = {
			data: null,
			calendars: null
		}

		this.getData = this.getData.bind(this);
	}

	componentDidMount() {
		this.getData();
	}

	getData() {
		let mongo = process.env.REACT_APP_MONGO;
		let mongoAPI = "https://api.mlab.com/api/1/databases/funily/collections/categoryStats?apiKey=" + mongo
		
		fetch(mongoAPI)
		.then(res => {
			return res.json();
		})
		.then(function(jsonRes){
			let calendars = jsonRes.map((category,index)=> (
				<CategoryCalendar
					category={category}
					key={index}
				/>
			))
			this.setState({calendars})
		}.bind(this))
		.catch(err => console.log('error getting stats',err));



	}

	render() {
		if(this.state.calendars){
			return (
				<div style={styles.container}>
				
				{ this.state.calendars }
				
				</div>
			)
		}
		return (
			<div style={styles.container}>
				<h1>Loading Data...</h1>
			</div>
		);
	}
}

const styles ={
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: "center",
		paddingTop: "20px",
		paddingLeft: '50px',
		marginTop: 100
	}
}


// WEBPACK FOOTER //
// ./src/components/admin/Calendar.js